import { motion } from "framer-motion";

const icon = {
  hidden: {
    opacity: 0,
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
  },
};

export const Logo = () => {
  return (
    <motion.svg width="32" height="33" viewBox="0 0 32 33">
      <g fill="none" fillRule="evenodd">
        <g fill="#FFD400">
          <motion.path
            fill="#FFD400"
            stroke="#FFD400"
            fillRule="evenodd"
            strokeWidth="0"
            variants={icon}
            initial="hidden"
            animate="visible"
            transition={{
              default: { duration: 2, ease: "easeInOut" },
            }}
            d="M21 13.447l8.21 12.334H32l-9.61-14.437zM12.617 6.188L0 25.78h2.757L12.923 9.993 14 8.32z"
          />
          <motion.path
            fill="#FFD400"
            stroke="#FFD400"
            fillRule="evenodd"
            strokeWidth="0"
            variants={icon}
            initial="hidden"
            animate="visible"
            transition={{
              default: { duration: 2, ease: "easeInOut" },
            }}
            d="M6 25.781h19l-6.322-9.76-1.423 2.212 3.385 5.225H10.348l9.689-15.061-1.432-2.21z"
          />
        </g>
      </g>
    </motion.svg>
  );
};
